import { SVG_DrawLine } from "./SVG_DrawLine.js";
import { Div2Floor } from "./Div2Floor.js";

export function SVG_DrawDashLine(x, y, width, height, fillColor, drawElement) {
  var my = y + Div2Floor(height);
  var x1 = x + 1;
  var x2 = x + width - 2;

  SVG_DrawLine(x1, my, x2, my, fillColor, 2, true, false, drawElement);
}
